module.exports = __webpack_public_path__ + "img/s1-notice.2e8da0e3.png";